import { NgModule } from '@angular/core';
import { DurationPipe } from './duration/duration';
import { DateFormatterPipe } from './date-formatter/date-formatter';
import { LineBreakPipe } from './line-break/line-break';

@NgModule({
    declarations: [
        DurationPipe,
        DateFormatterPipe,
        LineBreakPipe
    ],
    imports: [],
    providers: [
        DurationPipe,
        DateFormatterPipe,
        LineBreakPipe
    ],
    exports: [
        DurationPipe,
        DateFormatterPipe,
        LineBreakPipe
    ]
})
export class PipesModule {
}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts